import axios from 'axios';
import { attachSessionExpiryInterceptor } from '../utils/sessionExpiry';
import { attachStaffViewInterceptors } from '../staffView/staffViewSession';

attachSessionExpiryInterceptor(axios);
// Staff view (issue 1206): a no-op unless this tab holds a staff-view token.
attachStaffViewInterceptors(axios);

function resolveApiBaseUrl(rawValue) {
  const fallback = '/api';
  const raw = String(rawValue || fallback).trim();
  const normalizedRaw = raw.replace(/\/+$/, '') || fallback;

  if (typeof window === 'undefined') {
    return normalizedRaw;
  }

  try {
    const resolved = new URL(normalizedRaw, window.location.origin);
    const current = new URL(window.location.href);

    // Harden against mixed-content or internal-container port leakage from env config.
    if (current.protocol === 'https:' && resolved.protocol === 'http:') {
      resolved.protocol = 'https:';
    }
    if (resolved.hostname === current.hostname && resolved.port === '8080') {
      resolved.port = '';
    }

    const resolvedPath = resolved.pathname.replace(/\/+$/, '') || fallback;
    if (resolved.origin === current.origin) {
      return `${resolvedPath}${resolved.search}`;
    }
    return `${resolved.origin}${resolvedPath}${resolved.search}`;
  } catch {
    return normalizedRaw;
  }
}

const runtimeApiBaseUrl =
  typeof window !== 'undefined'
    ? window.__RSWORKS_RUNTIME_CONFIG__?.apiBaseUrl
    : undefined;
const rawApiBaseUrl = runtimeApiBaseUrl || import.meta.env.VITE_API_BASE_URL || '/api';
const apiBaseUrl = resolveApiBaseUrl(rawApiBaseUrl);
const globalAxiosBaseUrl = apiBaseUrl.endsWith('/api')
  ? apiBaseUrl.slice(0, -4)
  : apiBaseUrl;

// Many legacy calls still use absolute "/api/..." paths. Set axios global base
// to the API origin (without trailing /api) so those requests resolve correctly
// in staging where web and API live on different domains.
axios.defaults.baseURL = globalAxiosBaseUrl;
axios.defaults.withCredentials = true;

export const api = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

attachSessionExpiryInterceptor(api);
attachStaffViewInterceptors(api);
